'use strict';

var _defineProperty = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var axios = require('axios');

var qs = require('qs');

var isBuffer = require('is-buffer');

var isStream = require('is-stream');

var defaultBaseUrl = 'https://api.saasify.sh';

module.exports = /*#__PURE__*/function () {
  function SaasifyClient() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, SaasifyClient);

    var _opts$baseUrl = opts.baseUrl,
        baseUrl = _opts$baseUrl === void 0 ? defaultBaseUrl : _opts$baseUrl,
        user = opts.user,
        token = opts.token,
        teamId = opts.teamId,
        teamSlug = opts.teamSlug;
    this._baseUrl = baseUrl;
    this._user = user;
    this._token = token;
    this._teamId = teamId;
    this._teamSlug = teamSlug;

    if (!!user !== !!token) {
      throw new Error('user must be passed if and only if token is passed');
    }

    this._reset();
  }

  _createClass(SaasifyClient, [{
    key: "signin",
    // --------------------------------------------------------------------------
    // Auth
    // --------------------------------------------------------------------------
    value: function () {
      var _signin = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(data) {
        var _this = this;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", this._request({
                  url: "/1/auth/signin",
                  method: 'put',
                  params: this._params,
                  data: data
                }).then(function (res) {
                  return res.data;
                }).then(function (data) {
                  _this._token = data.token;
                  _this._user = data.user;
                  _this._teamId = undefined;
                  _this._teamSlug = undefined;
                  return data;
                }));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function signin(_x) {
        return _signin.apply(this, arguments);
      }

      return signin;
    }()
  }, {
    key: "signup",
    value: function () {
      var _signup = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(data) {
        var _this2 = this;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", this._request({
                  url: "/1/auth/signup",
                  method: 'post',
                  params: this._params,
                  data: data
                }).then(function (res) {
                  return res.data;
                }).then(function (data) {
                  _this2._token = data.token;
                  _this2._user = data.user;
                  _this2._teamId = undefined;
                  _this2._teamSlug = undefined;
                  return data;
                }));

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function signup(_x2) {
        return _signup.apply(this, arguments);
      }

      return signup;
    }()
  }, {
    key: "signupForBeta",
    value: function () {
      var _signupForBeta = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(data) {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt("return", this._request({
                  url: "/1/auth/signup-for-beta",
                  method: 'post',
                  params: this._params,
                  data: data
                }).then(function (res) {
                  return res.data;
                }));

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function signupForBeta(_x3) {
        return _signupForBeta.apply(this, arguments);
      }

      return signupForBeta;
    }()
  }, {
    key: "authWithGitHub",
    value: function () {
      var _authWithGitHub = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(data) {
        var _this3 = this;

        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                return _context4.abrupt("return", this._request({
                  url: "/1/auth/github",
                  method: 'put',
                  params: this._params,
                  data: data
                }).then(function (res) {
                  return res.data;
                }).then(function (data) {
                  _this3._token = data.token;
                  _this3._user = data.user;
                  _this3._teamId = undefined;
                  _this3._teamSlug = undefined;
                  return data;
                }));

              case 1:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function authWithGitHub(_x4) {
        return _authWithGitHub.apply(this, arguments);
      }

      return authWithGitHub;
    }()
  }, {
    key: "getGoogleAuthUrl",
    value: function () {
      var _getGoogleAuthUrl = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        var params,
            _args5 = arguments;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                params = _args5.length > 0 && _args5[0] !== undefined ? _args5[0] : {};
                return _context5.abrupt("return", this._request({
                  url: "/1/auth/google/url",
                  method: 'get',
                  params: params
                }).then(function (res) {
                  return res.data;
                }));

              case 2:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function getGoogleAuthUrl() {
        return _getGoogleAuthUrl.apply(this, arguments);
      }

      return getGoogleAuthUrl;
    }()
  }, {
    key: "authWithGoogle",
    value: function () {
      var _authWithGoogle = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(data, params) {
        var _this4 = this;

        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                return _context6.abrupt("return", this._request({
                  url: "/1/auth/google",
                  method: 'put',
                  params: _objectSpread(_objectSpread({}, this._params), params),
                  data: data
                }).then(function (res) {
                  return res.data;
                }).then(function (data) {
                  _this4._token = data.token;
                  _this4._user = data.user;
                  _this4._teamId = undefined;
                  _this4._teamSlug = undefined;
                  return data;
                }));

              case 1:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function authWithGoogle(_x5, _x6) {
        return _authWithGoogle.apply(this, arguments);
      }

      return authWithGoogle;
    }()
  }, {
    key: "authWithStripe",
    value: function () {
      var _authWithStripe = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(data) {
        var _this5 = this;

        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                return _context7.abrupt("return", this._request({
                  url: "/1/auth/stripe",
                  method: 'put',
                  params: this._params,
                  data: data
                }).then(function (res) {
                  return res.data;
                }).then(function (data) {
                  _this5._token = data.token;
                  _this5._user = data.user;
                  _this5._teamId = undefined;
                  _this5._teamSlug = undefined;
                  return data;
                }));

              case 1:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function authWithStripe(_x7) {
        return _authWithStripe.apply(this, arguments);
      }

      return authWithStripe;
    }()
  }, {
    key: "authWithSpotify",
    value: function () {
      var _authWithSpotify = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(data) {
        var _this6 = this;

        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                return _context8.abrupt("return", this._request({
                  url: "/1/auth/spotify",
                  method: 'put',
                  params: this._params,
                  data: data
                }).then(function (res) {
                  return res.data;
                }).then(function (data) {
                  _this6._token = data.token;
                  _this6._user = data.user;
                  _this6._teamId = undefined;
                  _this6._teamSlug = undefined;
                  return data;
                }));

              case 1:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function authWithSpotify(_x8) {
        return _authWithSpotify.apply(this, arguments);
      }

      return authWithSpotify;
    }()
  }, {
    key: "authWithLinkedIn",
    value: function () {
      var _authWithLinkedIn = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(data) {
        var _this7 = this;

        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                return _context9.abrupt("return", this._request({
                  url: "/1/auth/linkedin",
                  method: 'put',
                  params: this._params,
                  data: data
                }).then(function (res) {
                  return res.data;
                }).then(function (data) {
                  _this7._token = data.token;
                  _this7._user = data.user;
                  _this7._teamId = undefined;
                  _this7._teamSlug = undefined;
                  return data;
                }));

              case 1:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function authWithLinkedIn(_x9) {
        return _authWithLinkedIn.apply(this, arguments);
      }

      return authWithLinkedIn;
    }()
  }, {
    key: "getTwitterAuthUrl",
    value: function () {
      var _getTwitterAuthUrl = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10() {
        var params,
            _args10 = arguments;
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                params = _args10.length > 0 && _args10[0] !== undefined ? _args10[0] : {};
                return _context10.abrupt("return", this._request({
                  url: "/1/auth/twitter/url",
                  method: 'get',
                  params: params
                }).then(function (res) {
                  console.log(res);
                  return res.data;
                }));

              case 2:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function getTwitterAuthUrl() {
        return _getTwitterAuthUrl.apply(this, arguments);
      }

      return getTwitterAuthUrl;
    }()
  }, {
    key: "authWithTwitter",
    value: function () {
      var _authWithTwitter = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(data) {
        var _this8 = this;

        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                return _context11.abrupt("return", this._request({
                  url: "/1/auth/twitter",
                  method: 'put',
                  params: this._params,
                  data: data
                }).then(function (res) {
                  return res.data;
                }).then(function (data) {
                  _this8._token = data.token;
                  _this8._user = data.user;
                  _this8._teamId = undefined;
                  _this8._teamSlug = undefined;
                  return data;
                }));

              case 1:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));

      function authWithTwitter(_x10) {
        return _authWithTwitter.apply(this, arguments);
      }

      return authWithTwitter;
    }()
  }, {
    key: "signout",
    value: function () {
      var _signout = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12() {
        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                this._token = null;
                this._user = null;
                this._teamId = undefined;
                this._teamSlug = undefined;

              case 4:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this);
      }));

      function signout() {
        return _signout.apply(this, arguments);
      }

      return signout;
    }() // --------------------------------------------------------------------------
    // Users
    // --------------------------------------------------------------------------

  }, {
    key: "getMe",
    value: function () {
      var _getMe = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13() {
        return _regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                return _context13.abrupt("return", this._request({
                  url: "/1/me",
                  params: this._params
                }).then(function (res) {
                  return res.data;
                }));

              case 1:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, this);
      }));

      function getMe() {
        return _getMe.apply(this, arguments);
      }

      return getMe;
    }()
  }, {
    key: "updateMe",
    value: function () {
      var _updateMe = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14(data) {
        return _regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                return _context14.abrupt("return", this._request({
                  url: "/1/me",
                  method: 'put',
                  params: this._params,
                  data: data
                }).then(function (res) {
                  return res.data;
                }));

              case 1:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, this);
      }));

      function updateMe(_x11) {
        return _updateMe.apply(this, arguments);
      }

      return updateMe;
    }() // --------------------------------------------------------------------------
    // Projects
    // --------------------------------------------------------------------------

  }, {
    key: "createProject",
    value: function () {
      var _createProject = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee15(data) {
        return _regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                return _context15.abrupt("return", this._request({
                  url: "/1/projects",
                  method: 'post',
                  params: this._params,
                  data: data
                }).then(function (res) {
                  return res.data;
                }));

              case 1:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15, this);
      }));

      function createProject(_x12) {
        return _createProject.apply(this, arguments);
      }

      return createProject;
    }()
  }, {
    key: "getProject",
    value: function () {
      var _getProject = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee16(id) {
        var opts,
            _args16 = arguments;
        return _regeneratorRuntime.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                opts = _args16.length > 1 && _args16[1] !== undefined ? _args16[1] : {};
                return _context16.abrupt("return", this._request({
                  url: "/1/projects/".concat(id),
                  params: _objectSpread(_objectSpread({}, this._params), opts)
                }).then(function (res) {
                  return res.data;
                }));

              case 2:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16, this);
      }));

      function getProject(_x13) {
        return _getProject.apply(this, arguments);
      }

      return getProject;
    }()
  }, {
    key: "updateProject",
    value: function () {
      var _updateProject = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee17(project) {
        return _regeneratorRuntime.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                return _context17.abrupt("return", this._request({
                  url: "/1/projects/".concat(project.id),
                  method: 'put',
                  params: this._params,
                  data: project
                }).then(function (res) {
                  return res.data;
                }));

              case 1:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17, this);
      }));

      function updateProject(_x14) {
        return _updateProject.apply(this, arguments);
      }

      return updateProject;
    }() // enables stripe connect for a given project
    // (must be the project's owner and must have stripe connect enabled on your acct)

  }, {
    key: "enableStripeConnectForProject",
    value: function () {
      var _enableStripeConnectForProject = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee18(project) {
        return _regeneratorRuntime.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                return _context18.abrupt("return", this._request({
                  url: "/1/projects/connect/".concat(project.id),
                  method: 'put',
                  params: this._params
                }).then(function (res) {
                  return res.data;
                }));

              case 1:
              case "end":
                return _context18.stop();
            }
          }
        }, _callee18, this);
      }));

      function enableStripeConnectForProject(_x15) {
        return _enableStripeConnectForProject.apply(this, arguments);
      }

      return enableStripeConnectForProject;
    }()
  }, {
    key: "getProjectByAlias",
    value: function () {
      var _getProjectByAlias = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee19(alias) {
        var opts,
            _args19 = arguments;
        return _regeneratorRuntime.wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                opts = _args19.length > 1 && _args19[1] !== undefined ? _args19[1] : {};
                return _context19.abrupt("return", this._request({
                  url: "/1/projects/alias/".concat(alias),
                  params: _objectSpread(_objectSpread({}, this._params), opts)
                }).then(function (res) {
                  return res.data;
                }));

              case 2:
              case "end":
                return _context19.stop();
            }
          }
        }, _callee19, this);
      }));

      function getProjectByAlias(_x16) {
        return _getProjectByAlias.apply(this, arguments);
      }

      return getProjectByAlias;
    }()
  }, {
    key: "listProjects",
    value: function () {
      var _listProjects = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee20(opts) {
        return _regeneratorRuntime.wrap(function _callee20$(_context20) {
          while (1) {
            switch (_context20.prev = _context20.next) {
              case 0:
                return _context20.abrupt("return", this._request({
                  url: "/1/projects",
                  params: _objectSpread(_objectSpread({}, this._params), opts)
                }).then(function (res) {
                  return res.data;
                }));

              case 1:
              case "end":
                return _context20.stop();
            }
          }
        }, _callee20, this);
      }));

      function listProjects(_x17) {
        return _listProjects.apply(this, arguments);
      }

      return listProjects;
    }() // --------------------------------------------------------------------------
    // Providers
    // --------------------------------------------------------------------------

  }, {
    key: "getProvider",
    value: function () {
      var _getProvider = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee21(project) {
        return _regeneratorRuntime.wrap(function _callee21$(_context21) {
          while (1) {
            switch (_context21.prev = _context21.next) {
              case 0:
                return _context21.abrupt("return", this._request({
                  url: "/1/projects/provider/".concat(project.id),
                  params: this._params
                }).then(function (res) {
                  return res.data;
                }));

              case 1:
              case "end":
                return _context21.stop();
            }
          }
        }, _callee21, this);
      }));

      function getProvider(_x18) {
        return _getProvider.apply(this, arguments);
      }

      return getProvider;
    }()
  }, {
    key: "updateProvider",
    value: function () {
      var _updateProvider = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee22(project) {
        return _regeneratorRuntime.wrap(function _callee22$(_context22) {
          while (1) {
            switch (_context22.prev = _context22.next) {
              case 0:
                return _context22.abrupt("return", this._request({
                  url: "/1/projects/provider/".concat(project.id),
                  params: this._params,
                  method: 'put'
                }).then(function (res) {
                  return res.data;
                }));

              case 1:
              case "end":
                return _context22.stop();
            }
          }
        }, _callee22, this);
      }));

      function updateProvider(_x19) {
        return _updateProvider.apply(this, arguments);
      }

      return updateProvider;
    }() // --------------------------------------------------------------------------
    // Consumers
    // --------------------------------------------------------------------------

  }, {
    key: "createConsumer",
    value: function () {
      var _createConsumer = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee23(data) {
        return _regeneratorRuntime.wrap(function _callee23$(_context23) {
          while (1) {
            switch (_context23.prev = _context23.next) {
              case 0:
                return _context23.abrupt("return", this._request({
                  url: "/1/consumers",
                  method: 'post',
                  params: this._params,
                  data: data
                }).then(function (res) {
                  return res.data;
                }));

              case 1:
              case "end":
                return _context23.stop();
            }
          }
        }, _callee23, this);
      }));

      function createConsumer(_x20) {
        return _createConsumer.apply(this, arguments);
      }

      return createConsumer;
    }()
  }, {
    key: "getConsumer",
    value: function () {
      var _getConsumer = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee24(id) {
        return _regeneratorRuntime.wrap(function _callee24$(_context24) {
          while (1) {
            switch (_context24.prev = _context24.next) {
              case 0:
                return _context24.abrupt("return", this._request({
                  url: "/1/consumers/".concat(id),
                  params: this._params
                }).then(function (res) {
                  return res.data;
                }));

              case 1:
              case "end":
                return _context24.stop();
            }
          }
        }, _callee24, this);
      }));

      function getConsumer(_x21) {
        return _getConsumer.apply(this, arguments);
      }

      return getConsumer;
    }()
  }, {
    key: "removeConsumer",
    value: function () {
      var _removeConsumer = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee25(consumer) {
        return _regeneratorRuntime.wrap(function _callee25$(_context25) {
          while (1) {
            switch (_context25.prev = _context25.next) {
              case 0:
                return _context25.abrupt("return", this._request({
                  url: "/1/consumers/".concat(consumer.id),
                  params: this._params,
                  method: 'delete'
                }).then(function (res) {
                  return res.data;
                }));

              case 1:
              case "end":
                return _context25.stop();
            }
          }
        }, _callee25, this);
      }));

      function removeConsumer(_x22) {
        return _removeConsumer.apply(this, arguments);
      }

      return removeConsumer;
    }()
  }, {
    key: "updateConsumer",
    value: function () {
      var _updateConsumer = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee26(consumer) {
        return _regeneratorRuntime.wrap(function _callee26$(_context26) {
          while (1) {
            switch (_context26.prev = _context26.next) {
              case 0:
                return _context26.abrupt("return", this._request({
                  url: "/1/consumers/".concat(consumer.id),
                  params: this._params,
                  method: 'put'
                }).then(function (res) {
                  return res.data;
                }));

              case 1:
              case "end":
                return _context26.stop();
            }
          }
        }, _callee26, this);
      }));

      function updateConsumer(_x23) {
        return _updateConsumer.apply(this, arguments);
      }

      return updateConsumer;
    }()
  }, {
    key: "getConsumerByProject",
    value: function () {
      var _getConsumerByProject = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee27(projectId, opts) {
        return _regeneratorRuntime.wrap(function _callee27$(_context27) {
          while (1) {
            switch (_context27.prev = _context27.next) {
              case 0:
                return _context27.abrupt("return", this._request({
                  url: "/1/consumers/projects/".concat(projectId),
                  params: _objectSpread(_objectSpread({}, this._params), opts)
                }).then(function (res) {
                  return res.data;
                }));

              case 1:
              case "end":
                return _context27.stop();
            }
          }
        }, _callee27, this);
      }));

      function getConsumerByProject(_x24, _x25) {
        return _getConsumerByProject.apply(this, arguments);
      }

      return getConsumerByProject;
    }()
  }, {
    key: "listConsumers",
    value: function () {
      var _listConsumers = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee28(opts) {
        return _regeneratorRuntime.wrap(function _callee28$(_context28) {
          while (1) {
            switch (_context28.prev = _context28.next) {
              case 0:
                return _context28.abrupt("return", this._request({
                  url: "/1/consumers",
                  params: _objectSpread(_objectSpread({}, this._params), opts)
                }).then(function (res) {
                  return res.data;
                }));

              case 1:
              case "end":
                return _context28.stop();
            }
          }
        }, _callee28, this);
      }));

      function listConsumers(_x26) {
        return _listConsumers.apply(this, arguments);
      }

      return listConsumers;
    }() // --------------------------------------------------------------------------
    // Deployments
    // --------------------------------------------------------------------------
    // TODO: possibly increase the timeout for this HTTP call until the backend
    // deployment initialization is changed to be async

  }, {
    key: "createDeployment",
    value: function () {
      var _createDeployment = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee29(data) {
        return _regeneratorRuntime.wrap(function _callee29$(_context29) {
          while (1) {
            switch (_context29.prev = _context29.next) {
              case 0:
                return _context29.abrupt("return", this._request({
                  url: "/1/deployments",
                  method: 'post',
                  params: this._params,
                  data: data
                }).then(function (res) {
                  return res.data;
                }));

              case 1:
              case "end":
                return _context29.stop();
            }
          }
        }, _callee29, this);
      }));

      function createDeployment(_x27) {
        return _createDeployment.apply(this, arguments);
      }

      return createDeployment;
    }()
  }, {
    key: "getDeployment",
    value: function () {
      var _getDeployment = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee30(id) {
        var opts,
            _args30 = arguments;
        return _regeneratorRuntime.wrap(function _callee30$(_context30) {
          while (1) {
            switch (_context30.prev = _context30.next) {
              case 0:
                opts = _args30.length > 1 && _args30[1] !== undefined ? _args30[1] : {};
                return _context30.abrupt("return", this._request({
                  url: "/1/deployments/".concat(id),
                  params: _objectSpread(_objectSpread({}, this._params), opts)
                }).then(function (res) {
                  return res.data;
                }));

              case 2:
              case "end":
                return _context30.stop();
            }
          }
        }, _callee30, this);
      }));

      function getDeployment(_x28) {
        return _getDeployment.apply(this, arguments);
      }

      return getDeployment;
    }()
  }, {
    key: "updateDeployment",
    value: function () {
      var _updateDeployment = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee31(deployment) {
        return _regeneratorRuntime.wrap(function _callee31$(_context31) {
          while (1) {
            switch (_context31.prev = _context31.next) {
              case 0:
                return _context31.abrupt("return", this._request({
                  url: "/1/deployments/".concat(deployment.id),
                  method: 'put',
                  params: this._params,
                  data: deployment
                }).then(function (res) {
                  return res.data;
                }));

              case 1:
              case "end":
                return _context31.stop();
            }
          }
        }, _callee31, this);
      }));

      function updateDeployment(_x29) {
        return _updateDeployment.apply(this, arguments);
      }

      return updateDeployment;
    }()
  }, {
    key: "removeDeployment",
    value: function () {
      var _removeDeployment = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee32(id) {
        return _regeneratorRuntime.wrap(function _callee32$(_context32) {
          while (1) {
            switch (_context32.prev = _context32.next) {
              case 0:
                return _context32.abrupt("return", this._request({
                  url: "/1/deployments/".concat(id),
                  method: 'delete',
                  params: this._params
                }).then(function (res) {
                  return res.data;
                }));

              case 1:
              case "end":
                return _context32.stop();
            }
          }
        }, _callee32, this);
      }));

      function removeDeployment(_x30) {
        return _removeDeployment.apply(this, arguments);
      }

      return removeDeployment;
    }()
  }, {
    key: "listDeployments",
    value: function () {
      var _listDeployments = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee33() {
        var where,
            opts,
            _args33 = arguments;
        return _regeneratorRuntime.wrap(function _callee33$(_context33) {
          while (1) {
            switch (_context33.prev = _context33.next) {
              case 0:
                where = _args33.length > 0 && _args33[0] !== undefined ? _args33[0] : {};
                opts = _args33.length > 1 && _args33[1] !== undefined ? _args33[1] : {};
                return _context33.abrupt("return", this._request({
                  url: "/1/deployments",
                  params: _objectSpread(_objectSpread({}, this._params), {}, {
                    where: where
                  }, opts)
                }).then(function (res) {
                  return res.data;
                }));

              case 3:
              case "end":
                return _context33.stop();
            }
          }
        }, _callee33, this);
      }));

      function listDeployments() {
        return _listDeployments.apply(this, arguments);
      }

      return listDeployments;
    }()
  }, {
    key: "publishDeployment",
    value: function () {
      var _publishDeployment = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee34(deploymentId, data) {
        return _regeneratorRuntime.wrap(function _callee34$(_context34) {
          while (1) {
            switch (_context34.prev = _context34.next) {
              case 0:
                return _context34.abrupt("return", this._request({
                  url: "/1/deployments/publish/".concat(deploymentId),
                  method: 'put',
                  params: this._params,
                  data: data
                }).then(function (res) {
                  return res.data;
                }));

              case 1:
              case "end":
                return _context34.stop();
            }
          }
        }, _callee34, this);
      }));

      function publishDeployment(_x31, _x32) {
        return _publishDeployment.apply(this, arguments);
      }

      return publishDeployment;
    }() // --------------------------------------------------------------------------
    // Teams
    // --------------------------------------------------------------------------

  }, {
    key: "createTeam",
    value: function () {
      var _createTeam = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee35(data) {
        return _regeneratorRuntime.wrap(function _callee35$(_context35) {
          while (1) {
            switch (_context35.prev = _context35.next) {
              case 0:
                return _context35.abrupt("return", this._request({
                  url: "/1/teams",
                  method: 'post',
                  params: this._params,
                  data: data
                }).then(function (res) {
                  return res.data;
                }));

              case 1:
              case "end":
                return _context35.stop();
            }
          }
        }, _callee35, this);
      }));

      function createTeam(_x33) {
        return _createTeam.apply(this, arguments);
      }

      return createTeam;
    }()
  }, {
    key: "getTeam",
    value: function () {
      var _getTeam = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee36(id) {
        var opts,
            _args36 = arguments;
        return _regeneratorRuntime.wrap(function _callee36$(_context36) {
          while (1) {
            switch (_context36.prev = _context36.next) {
              case 0:
                opts = _args36.length > 1 && _args36[1] !== undefined ? _args36[1] : {};
                return _context36.abrupt("return", this._request({
                  url: "/1/teams/".concat(id),
                  params: _objectSpread(_objectSpread({}, this._params), opts)
                }).then(function (res) {
                  return res.data;
                }));

              case 2:
              case "end":
                return _context36.stop();
            }
          }
        }, _callee36, this);
      }));

      function getTeam(_x34) {
        return _getTeam.apply(this, arguments);
      }

      return getTeam;
    }()
  }, {
    key: "updateTeam",
    value: function () {
      var _updateTeam = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee37(team) {
        return _regeneratorRuntime.wrap(function _callee37$(_context37) {
          while (1) {
            switch (_context37.prev = _context37.next) {
              case 0:
                return _context37.abrupt("return", this._request({
                  url: "/1/teams/".concat(team.id),
                  method: 'put',
                  params: this._params,
                  data: team
                }).then(function (res) {
                  return res.data;
                }));

              case 1:
              case "end":
                return _context37.stop();
            }
          }
        }, _callee37, this);
      }));

      function updateTeam(_x35) {
        return _updateTeam.apply(this, arguments);
      }

      return updateTeam;
    }()
  }, {
    key: "removeTeam",
    value: function () {
      var _removeTeam = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee38(teamId) {
        return _regeneratorRuntime.wrap(function _callee38$(_context38) {
          while (1) {
            switch (_context38.prev = _context38.next) {
              case 0:
                return _context38.abrupt("return", this._request({
                  url: "/1/teams/".concat(teamId),
                  params: this._params,
                  method: 'delete'
                }).then(function (res) {
                  return res.data;
                }));

              case 1:
              case "end":
                return _context38.stop();
            }
          }
        }, _callee38, this);
      }));

      function removeTeam(_x36) {
        return _removeTeam.apply(this, arguments);
      }

      return removeTeam;
    }()
  }, {
    key: "listTeams",
    value: function () {
      var _listTeams = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee39() {
        var where,
            opts,
            _args39 = arguments;
        return _regeneratorRuntime.wrap(function _callee39$(_context39) {
          while (1) {
            switch (_context39.prev = _context39.next) {
              case 0:
                where = _args39.length > 0 && _args39[0] !== undefined ? _args39[0] : {};
                opts = _args39.length > 1 && _args39[1] !== undefined ? _args39[1] : {};
                return _context39.abrupt("return", this._request({
                  url: "/1/teams",
                  params: _objectSpread(_objectSpread({}, this._params), {}, {
                    where: where
                  }, opts)
                }).then(function (res) {
                  return res.data;
                }));

              case 3:
              case "end":
                return _context39.stop();
            }
          }
        }, _callee39, this);
      }));

      function listTeams() {
        return _listTeams.apply(this, arguments);
      }

      return listTeams;
    }()
  }, {
    key: "inviteTeamMember",
    value: function () {
      var _inviteTeamMember = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee40(teamId, member) {
        return _regeneratorRuntime.wrap(function _callee40$(_context40) {
          while (1) {
            switch (_context40.prev = _context40.next) {
              case 0:
                return _context40.abrupt("return", this._request({
                  url: "/1/teams/".concat(teamId, "/members"),
                  method: 'post',
                  params: this._params,
                  data: member
                }).then(function (res) {
                  return res.data;
                }));

              case 1:
              case "end":
                return _context40.stop();
            }
          }
        }, _callee40, this);
      }));

      function inviteTeamMember(_x37, _x38) {
        return _inviteTeamMember.apply(this, arguments);
      }

      return inviteTeamMember;
    }()
  }, {
    key: "updateTeamMember",
    value: function () {
      var _updateTeamMember = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee41(teamId, member) {
        return _regeneratorRuntime.wrap(function _callee41$(_context41) {
          while (1) {
            switch (_context41.prev = _context41.next) {
              case 0:
                return _context41.abrupt("return", this._request({
                  url: "/1/teams/".concat(teamId, "/members/").concat(member.username),
                  method: 'put',
                  params: this._params,
                  data: member
                }).then(function (res) {
                  return res.data;
                }));

              case 1:
              case "end":
                return _context41.stop();
            }
          }
        }, _callee41, this);
      }));

      function updateTeamMember(_x39, _x40) {
        return _updateTeamMember.apply(this, arguments);
      }

      return updateTeamMember;
    }()
  }, {
    key: "removeTeamMember",
    value: function () {
      var _removeTeamMember = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee42(teamId, member) {
        return _regeneratorRuntime.wrap(function _callee42$(_context42) {
          while (1) {
            switch (_context42.prev = _context42.next) {
              case 0:
                return _context42.abrupt("return", this._request({
                  url: "/1/teams/".concat(teamId, "/members/").concat(member.username),
                  params: this._params,
                  method: 'delete'
                }).then(function (res) {
                  return res.data;
                }));

              case 1:
              case "end":
                return _context42.stop();
            }
          }
        }, _callee42, this);
      }));

      function removeTeamMember(_x41, _x42) {
        return _removeTeamMember.apply(this, arguments);
      }

      return removeTeamMember;
    }() // --------------------------------------------------------------------------
    // Logs
    // --------------------------------------------------------------------------

  }, {
    key: "getLogs",
    value: function () {
      var _getLogs = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee43(identifier, opts) {
        return _regeneratorRuntime.wrap(function _callee43$(_context43) {
          while (1) {
            switch (_context43.prev = _context43.next) {
              case 0:
                return _context43.abrupt("return", this._request({
                  url: "/1/logs",
                  method: 'put',
                  params: this._params,
                  data: _objectSpread(_objectSpread({}, opts), {}, {
                    identifier: identifier
                  })
                }).then(function (res) {
                  return res.data;
                }));

              case 1:
              case "end":
                return _context43.stop();
            }
          }
        }, _callee43, this);
      }));

      function getLogs(_x43, _x44) {
        return _getLogs.apply(this, arguments);
      }

      return getLogs;
    }() // --------------------------------------------------------------------------
    // Billing
    // --------------------------------------------------------------------------

  }, {
    key: "getBilling",
    value: function () {
      var _getBilling = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee44() {
        return _regeneratorRuntime.wrap(function _callee44$(_context44) {
          while (1) {
            switch (_context44.prev = _context44.next) {
              case 0:
                return _context44.abrupt("return", this._request({
                  url: "/1/billing",
                  params: this._params
                }).then(function (res) {
                  return res.data;
                }));

              case 1:
              case "end":
                return _context44.stop();
            }
          }
        }, _callee44, this);
      }));

      function getBilling() {
        return _getBilling.apply(this, arguments);
      }

      return getBilling;
    }()
  }, {
    key: "getBillingAccount",
    value: function () {
      var _getBillingAccount = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee45() {
        return _regeneratorRuntime.wrap(function _callee45$(_context45) {
          while (1) {
            switch (_context45.prev = _context45.next) {
              case 0:
                return _context45.abrupt("return", this._request({
                  url: "/1/billing/account",
                  params: this._params
                }).then(function (res) {
                  return res.data;
                }));

              case 1:
              case "end":
                return _context45.stop();
            }
          }
        }, _callee45, this);
      }));

      function getBillingAccount() {
        return _getBillingAccount.apply(this, arguments);
      }

      return getBillingAccount;
    }()
  }, {
    key: "getBillingDashboard",
    value: function () {
      var _getBillingDashboard = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee46() {
        return _regeneratorRuntime.wrap(function _callee46$(_context46) {
          while (1) {
            switch (_context46.prev = _context46.next) {
              case 0:
                return _context46.abrupt("return", this._request({
                  url: "/1/billing/dashboard",
                  params: this._params
                }).then(function (res) {
                  return res.data;
                }));

              case 1:
              case "end":
                return _context46.stop();
            }
          }
        }, _callee46, this);
      }));

      function getBillingDashboard() {
        return _getBillingDashboard.apply(this, arguments);
      }

      return getBillingDashboard;
    }()
  }, {
    key: "listBillingSources",
    value: function () {
      var _listBillingSources = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee47() {
        return _regeneratorRuntime.wrap(function _callee47$(_context47) {
          while (1) {
            switch (_context47.prev = _context47.next) {
              case 0:
                return _context47.abrupt("return", this._request({
                  url: "/1/billing/sources",
                  params: this._params
                }).then(function (res) {
                  return res.data;
                }));

              case 1:
              case "end":
                return _context47.stop();
            }
          }
        }, _callee47, this);
      }));

      function listBillingSources() {
        return _listBillingSources.apply(this, arguments);
      }

      return listBillingSources;
    }()
  }, {
    key: "addBillingSource",
    value: function () {
      var _addBillingSource = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee48(data) {
        return _regeneratorRuntime.wrap(function _callee48$(_context48) {
          while (1) {
            switch (_context48.prev = _context48.next) {
              case 0:
                return _context48.abrupt("return", this._request({
                  url: "/1/billing/sources",
                  method: 'post',
                  params: this._params,
                  data: data
                }).then(function (res) {
                  return res.data;
                }));

              case 1:
              case "end":
                return _context48.stop();
            }
          }
        }, _callee48, this);
      }));

      function addBillingSource(_x45) {
        return _addBillingSource.apply(this, arguments);
      }

      return addBillingSource;
    }()
  }, {
    key: "removeBillingSource",
    value: function () {
      var _removeBillingSource = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee49(id) {
        return _regeneratorRuntime.wrap(function _callee49$(_context49) {
          while (1) {
            switch (_context49.prev = _context49.next) {
              case 0:
                return _context49.abrupt("return", this._request({
                  url: "/1/billing/sources/".concat(id),
                  method: 'delete',
                  params: this._params
                }).then(function (res) {
                  return res.data;
                }));

              case 1:
              case "end":
                return _context49.stop();
            }
          }
        }, _callee49, this);
      }));

      function removeBillingSource(_x46) {
        return _removeBillingSource.apply(this, arguments);
      }

      return removeBillingSource;
    }()
  }, {
    key: "setDefaultBillingSource",
    value: function () {
      var _setDefaultBillingSource = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee50(id) {
        return _regeneratorRuntime.wrap(function _callee50$(_context50) {
          while (1) {
            switch (_context50.prev = _context50.next) {
              case 0:
                return _context50.abrupt("return", this._request({
                  url: "/1/billing/sources/".concat(id, "/set-default"),
                  method: 'put',
                  params: this._params
                }).then(function (res) {
                  return res.data;
                }));

              case 1:
              case "end":
                return _context50.stop();
            }
          }
        }, _callee50, this);
      }));

      function setDefaultBillingSource(_x47) {
        return _setDefaultBillingSource.apply(this, arguments);
      }

      return setDefaultBillingSource;
    }()
  }, {
    key: "listBillingInvoices",
    value: function () {
      var _listBillingInvoices = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee51() {
        var opts,
            _args51 = arguments;
        return _regeneratorRuntime.wrap(function _callee51$(_context51) {
          while (1) {
            switch (_context51.prev = _context51.next) {
              case 0:
                opts = _args51.length > 0 && _args51[0] !== undefined ? _args51[0] : {};
                return _context51.abrupt("return", this._request({
                  url: "/1/billing/invoices",
                  params: _objectSpread(_objectSpread({}, this._params), opts)
                }).then(function (res) {
                  return res.data;
                }));

              case 2:
              case "end":
                return _context51.stop();
            }
          }
        }, _callee51, this);
      }));

      function listBillingInvoices() {
        return _listBillingInvoices.apply(this, arguments);
      }

      return listBillingInvoices;
    }()
  }, {
    key: "listBillingInvoicesForConsumer",
    value: function () {
      var _listBillingInvoicesForConsumer = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee52(consumer) {
        var opts,
            _args52 = arguments;
        return _regeneratorRuntime.wrap(function _callee52$(_context52) {
          while (1) {
            switch (_context52.prev = _context52.next) {
              case 0:
                opts = _args52.length > 1 && _args52[1] !== undefined ? _args52[1] : {};
                return _context52.abrupt("return", this._request({
                  url: "/1/billing/invoices/".concat(consumer.id),
                  params: _objectSpread(_objectSpread({}, this._params), opts)
                }).then(function (res) {
                  return res.data;
                }));

              case 2:
              case "end":
                return _context52.stop();
            }
          }
        }, _callee52, this);
      }));

      function listBillingInvoicesForConsumer(_x48) {
        return _listBillingInvoicesForConsumer.apply(this, arguments);
      }

      return listBillingInvoicesForConsumer;
    }()
  }, {
    key: "listBillingUsageForConsumer",
    value: function () {
      var _listBillingUsageForConsumer = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee53(consumer) {
        var opts,
            _args53 = arguments;
        return _regeneratorRuntime.wrap(function _callee53$(_context53) {
          while (1) {
            switch (_context53.prev = _context53.next) {
              case 0:
                opts = _args53.length > 1 && _args53[1] !== undefined ? _args53[1] : {};
                return _context53.abrupt("return", this._request({
                  url: "/1/billing/usage/".concat(consumer.id),
                  params: _objectSpread(_objectSpread({}, this._params), opts)
                }).then(function (res) {
                  return res.data;
                }));

              case 2:
              case "end":
                return _context53.stop();
            }
          }
        }, _callee53, this);
      }));

      function listBillingUsageForConsumer(_x49) {
        return _listBillingUsageForConsumer.apply(this, arguments);
      }

      return listBillingUsageForConsumer;
    }() // --------------------------------------------------------------------------
    // Secrets
    // --------------------------------------------------------------------------

  }, {
    key: "listSecrets",
    value: function () {
      var _listSecrets = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee54() {
        return _regeneratorRuntime.wrap(function _callee54$(_context54) {
          while (1) {
            switch (_context54.prev = _context54.next) {
              case 0:
                return _context54.abrupt("return", this._request({
                  url: "/1/secrets",
                  params: this._params
                }).then(function (res) {
                  return res.data;
                }));

              case 1:
              case "end":
                return _context54.stop();
            }
          }
        }, _callee54, this);
      }));

      function listSecrets() {
        return _listSecrets.apply(this, arguments);
      }

      return listSecrets;
    }()
  }, {
    key: "addSecret",
    value: function () {
      var _addSecret = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee55(name, value) {
        return _regeneratorRuntime.wrap(function _callee55$(_context55) {
          while (1) {
            switch (_context55.prev = _context55.next) {
              case 0:
                return _context55.abrupt("return", this._request({
                  url: "/1/secrets",
                  method: 'post',
                  params: this._params,
                  data: {
                    name: name,
                    value: value
                  }
                }).then(function (res) {
                  return res.data;
                }));

              case 1:
              case "end":
                return _context55.stop();
            }
          }
        }, _callee55, this);
      }));

      function addSecret(_x50, _x51) {
        return _addSecret.apply(this, arguments);
      }

      return addSecret;
    }()
  }, {
    key: "removeSecret",
    value: function () {
      var _removeSecret = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee56(name) {
        return _regeneratorRuntime.wrap(function _callee56$(_context56) {
          while (1) {
            switch (_context56.prev = _context56.next) {
              case 0:
                return _context56.abrupt("return", this._request({
                  url: "/1/secrets/".concat(name),
                  method: 'delete',
                  params: this._params
                }).then(function (res) {
                  return res.data;
                }));

              case 1:
              case "end":
                return _context56.stop();
            }
          }
        }, _callee56, this);
      }));

      function removeSecret(_x52) {
        return _removeSecret.apply(this, arguments);
      }

      return removeSecret;
    }()
  }, {
    key: "renameSecret",
    value: function () {
      var _renameSecret = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee57(name, newName) {
        return _regeneratorRuntime.wrap(function _callee57$(_context57) {
          while (1) {
            switch (_context57.prev = _context57.next) {
              case 0:
                return _context57.abrupt("return", this._request({
                  url: "/1/secrets/".concat(name),
                  method: 'put',
                  params: this._params,
                  data: {
                    name: newName
                  }
                }).then(function (res) {
                  return res.data;
                }));

              case 1:
              case "end":
                return _context57.stop();
            }
          }
        }, _callee57, this);
      }));

      function renameSecret(_x53, _x54) {
        return _renameSecret.apply(this, arguments);
      }

      return renameSecret;
    }() // --------------------------------------------------------------------------
    // Search
    // --------------------------------------------------------------------------

  }, {
    key: "searchProjects",
    value: function () {
      var _searchProjects = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee58(query) {
        var opts,
            _args58 = arguments;
        return _regeneratorRuntime.wrap(function _callee58$(_context58) {
          while (1) {
            switch (_context58.prev = _context58.next) {
              case 0:
                opts = _args58.length > 1 && _args58[1] !== undefined ? _args58[1] : {};
                return _context58.abrupt("return", this._request({
                  url: "/1/search/projects",
                  params: _objectSpread(_objectSpread({}, this._params), {}, {
                    query: query
                  }, opts)
                }).then(function (res) {
                  return res.data;
                }));

              case 2:
              case "end":
                return _context58.stop();
            }
          }
        }, _callee58, this);
      }));

      function searchProjects(_x55) {
        return _searchProjects.apply(this, arguments);
      }

      return searchProjects;
    }() // --------------------------------------------------------------------------
    // Uploads
    // --------------------------------------------------------------------------

    /**
     * @param {File|Buffer|Stream} input - Data to upload
     * - [File](https://developer.mozilla.org/en-US/docs/Web/API/File) in browser
     * - [Buffer](https://nodejs.org/api/buffer.html) in Node.js
     * - [Stream](https://nodejs.org/api/stream.html) in Node.js
     */

  }, {
    key: "upload",
    value: function () {
      var _upload = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee59(input) {
        var opts,
            type,
            name,
            _yield$this$_getUploa,
            key,
            uploadUrl,
            url,
            _args59 = arguments;

        return _regeneratorRuntime.wrap(function _callee59$(_context59) {
          while (1) {
            switch (_context59.prev = _context59.next) {
              case 0:
                opts = _args59.length > 1 && _args59[1] !== undefined ? _args59[1] : {};
                type = opts.type;
                name = opts.name;

                if (!isBuffer(input) && !isStream(input)) {
                  type = input.type;
                  name = input.name;
                }

                if (type) {
                  _context59.next = 6;
                  break;
                }

                throw new Error('upload requires a valid mime type');

              case 6:
                _context59.next = 8;
                return this._getUploadRequest({
                  type: type,
                  name: name
                });

              case 8:
                _yield$this$_getUploa = _context59.sent;
                key = _yield$this$_getUploa.key;
                uploadUrl = _yield$this$_getUploa.uploadUrl;
                url = _yield$this$_getUploa.url;
                console.log('upload', {
                  key: key,
                  uploadUrl: uploadUrl,
                  url: url,
                  type: type,
                  name: name
                });
                _context59.next = 15;
                return axios.put(uploadUrl, input, {
                  onUploadProgress: function onUploadProgress(event) {
                    if (opts.onUploadProgress) {
                      var progress = Math.floor(event.loaded * 100 / event.total);
                      opts.onUploadProgress(progress);
                    }
                  },
                  headers: {
                    'content-type': type
                  }
                });

              case 15:
                _context59.next = 17;
                return this._request({
                  url: "/1/uploads/finalize",
                  method: 'put',
                  data: {
                    key: key
                  }
                });

              case 17:
                return _context59.abrupt("return", url);

              case 18:
              case "end":
                return _context59.stop();
            }
          }
        }, _callee59, this);
      }));

      function upload(_x56) {
        return _upload.apply(this, arguments);
      }

      return upload;
    }()
  }, {
    key: "_getUploadRequest",
    value: function () {
      var _getUploadRequest2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee60(data) {
        return _regeneratorRuntime.wrap(function _callee60$(_context60) {
          while (1) {
            switch (_context60.prev = _context60.next) {
              case 0:
                return _context60.abrupt("return", this._request({
                  url: "/1/uploads",
                  method: 'post',
                  params: this._params,
                  data: data
                }).then(function (res) {
                  return res.data;
                }));

              case 1:
              case "end":
                return _context60.stop();
            }
          }
        }, _callee60, this);
      }));

      function _getUploadRequest(_x57) {
        return _getUploadRequest2.apply(this, arguments);
      }

      return _getUploadRequest;
    }() // --------------------------------------------------------------------------
    // Internal
    // --------------------------------------------------------------------------

  }, {
    key: "_reset",
    value: function _reset() {
      var headers = {};
      this._params = {};

      if (this._token) {
        headers.authorization = "Bearer ".concat(this._token);
      }

      if (this._teamId) {
        this._params.teamId = this._teamId;
      }

      this._request = axios.create({
        baseURL: this._baseUrl,
        responseType: 'json',
        headers: headers,
        paramsSerializer: function paramsSerializer(params) {
          return qs.stringify(params);
        }
      });
    }
  }, {
    key: "isAuthenticated",
    get: function get() {
      return !!this._token;
    }
  }, {
    key: "user",
    get: function get() {
      return this._user;
    },
    set: function set(user) {
      this._user = user;

      this._reset();
    }
  }, {
    key: "token",
    get: function get() {
      return this._token;
    },
    set: function set(token) {
      this._token = token;

      this._reset();
    }
  }, {
    key: "teamId",
    get: function get() {
      return this._teamId;
    },
    set: function set(teamId) {
      this._teamId = teamId;

      this._reset();
    }
  }, {
    key: "teamSlug",
    get: function get() {
      return this._teamSlug;
    }
  }, {
    key: "baseUrl",
    get: function get() {
      return this._baseUrl;
    }
  }]);

  return SaasifyClient;
}();